<div class="container" id="warranties">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="warranties-header-title"  class="section-title">{{ 'WARRANTIES.TITLE' | translate }}</h1>
          <p data-testid="warranties-header-subtitle" class="section-subtitle mt-1 text-base">{{ 'WARRANTIES.SUBTITLE' | translate }}</p>
        </div>
        <div class="flex items-end justify-between gap-4 actions-wr">
          <!-- Sort panel toggle -->
          <app-sort-panel
            [hidden]="activeTabIndex !== 0"
            [columns]="sortableColumns"
            [currentSort]="sortPanelSort"
            (sortChange)="onSortPanelChange($event)">
          </app-sort-panel>

          <!-- Filters toggle -->
          <button type="button" data-testid="btn-toggle-filters" class="btn outline-btn filters-btn" [hidden]="activeTabIndex !== 0" (click)="filtersPanel.toggleOpen()">
            {{ filtersPanel.isOpen ? ('FILTERS_PANEL.HIDE_FILTERS' | translate) : ('FILTERS_PANEL.DISPLAY_FILTERS' | translate) }}
          </button>

          @if (allowActivateWarranty) {
            <button data-testid="btn-new-warranty" class="btn primary-btn" (click)="goToActivateWarrantyForm()">{{
            'WARRANTIES.BTN_NEW' | translate }}</button>
          }
        </div>
      </div>

      <!-- Filters panel -->
      <app-filters-panel
        #filtersPanel
        [hidden]="activeTabIndex !== 0"
        [columns]="tableColumns"
        [storageKeyStrategy]="'tableName'"
        [tableName]="warrantiesTableName"
        [fieldOverrides]="filtersPanelFieldOverrides"
        (panelChange)="onFiltersPanelChange($event)">
      </app-filters-panel>

      <hr role="presentation" class="w-full mb-3 border-t" [class.mt-6]="activeTabIndex !== 0 || !filtersPanel.isOpen" [class.mt-1]="activeTabIndex === 0 && filtersPanel.isOpen">

      <div class="view-content-wr">

        <!-- Tabs -->
        <p-tabs [(value)]="activeTabIndex">
          <p-tablist>
            <p-tab [value]="0">
              {{ 'WARRANTIES.TABS.WARRANTIES_LIST' | translate }}
            </p-tab>
            <p-tab [value]="1">
              {{ 'WARRANTIES.TABS.GLOBAL_SEARCH' | translate }}
            </p-tab>
          </p-tablist>

          <p-tabpanels>
            <!-- Tab 1: Warranties List -->
            <p-tabpanel [value]="0">

              <div class="row">
                <div class="flex flex-col col-12 mb-2 text-wr">
                  <!-- main content -->
                  @if (tableColumns?.length) {
                    <p-table data-testid="table" [columns]="tableColumns" [value]="data" (onLazyLoad)="customSort($event)" [lazy]="true" [customSort]="true" [sortField]="primeTableSortField" [sortOrder]="primeTableSortOrder">
                      <ng-template #header let-columns>
                        <tr>
                          @for (col of columns; track col; let colIndex = $index) {
                            <!-- Normal sortable columns -->
                            @if (colIndex !== columns.length - 1 && col.sortable !== false) {
                              <th [pSortableColumn]="col.field">
                                <div class="header-wr">
                                  <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                                    {{ ('TABLE.HEADER.' + col.header) | translate }}
                                  </span>
                                  <span class="sort-icon" aria-hidden="true">
                                    @if (isColumnUnsorted(col.field)) {
                                      <i class="pi pi-sort-alt"></i>
                                    }
                                    @if (isColumnSortedAsc(col.field)) {
                                      <i class="pi pi-sort-amount-up-alt"></i>
                                    }
                                    @if (isColumnSortedDesc(col.field)) {
                                      <i class="pi pi-sort-amount-down-alt"></i>
                                    }
                                  </span>
                                </div>
                              </th>
                            }
                            <!-- Non-sortable columns -->
                            @if (colIndex !== columns.length - 1 && col.sortable === false) {
                              <th>
                                <div class="header-wr">
                                  <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                                    {{ ('TABLE.HEADER.' + col.header) | translate }}
                                  </span>
                                </div>
                              </th>
                            }
                            <!-- Actions column -->
                            @if (colIndex === columns.length - 1) {
                              <th>
                                <span data-testid="table-header-actions" class="col-name">{{ ('TABLE.HEADER.' + col.field) | translate }}</span>
                              </th>
                            }
                          }
                        </tr>
                      </ng-template>
                      <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
                        <tr>
                          @for (col of columns; track col; let colIndex = $index) {
                            <td
                              [ngClass]="{'actions-col': colIndex === columns.length -1}">
                              @if (colIndex !== columns.length-1) {
                                <span [attr.data-testid]="'cell-' + colIndex + '-' + i" class="p-column-title">{{ ('TABLE.HEADER.' + col.header) | translate  }}:</span>
                                {{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}
                              } @else {
                                <div class="flex justify-center">
                                  <button type="button" pTooltip="{{ 'WARRANTIES.TOOLTIP_VIEW_DETAILS' | translate }}"
                                    tooltipPosition="top"
                                    class="btn-icon-only ui-btn-view btn-icon icon-eye"
                                    (click)="goToWarrantyDetails($event, rowData.id)"
                                    [attr.data-testid]="'btn-view-' + i">
                                    <span class="btn-label">{{ 'WARRANTIES.VIEW_WARRANTY_DETAILS' | translate }}</span>
                                  </button>
                                </div>
                              }
                            </td>
                          }
                        </tr>
                      </ng-template>
                      <ng-template #emptymessage>
                        <tr>
                          <td [attr.colspan]="tableColumns.length">
                            {{ 'WARRANTIES.NO_DATA' | translate }}
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                    <!-- Pagination -->
                    <app-custom-paginator
                      data-testid="paginator"
                      [pageNumber]="pageNumber"
                      [rows]="pageSize"
                      [totalRecords]="page?.totalCount ?? 0"
                      [rowsPerPageOptions]="[10, 20, 30]"
                      [showCurrentPageReport]="true"
                      [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                      [disabled]="!page"
                      [alwaysShow]="true"
                      [tableName]="warrantiesTableName"
                      [showFirstLastIcon]="true"
                      [showPageLinks]="true"
                      [showPageSizeSelector]="true"
                      (onPageChange)="onPageChange($event)">
                    </app-custom-paginator>
                  } @else {
                    <div class="flex flex-col items-center justify-center gap-1 py-10 text-center no-cols-wr" data-testid="no-columns-message">
                      <p class="text-base font-semibold">{{ 'TABLE.NO_COLUMNS_TITLE' | translate }}</p>
                      <p class="text-base">{{ 'TABLE.NO_COLUMNS_MESSAGE' | translate }}</p>
                    </div>
                  }
                  <!-- /main content -->
                </div>
              </div>
            </p-tabpanel>
            <!-- /Tab 1 -->

            <!-- Tab 2: Global Warranties Search -->
            <p-tabpanel [value]="1">
              <div class="row">
                <div class="flex flex-col col-12 mb-2 text-wr">

                  <form [formGroup]="globalSearchFormGroup" (ngSubmit)="onGlobalSearchSubmit()" id="warranty-global-search" class="mb-6">

                    <div class="rounded-card">
                      <h3 class="border-b pb-3 mt-0 mb-3">{{ 'WARRANTIES.BTN_SEARCH' | translate }}</h3>

                      <div class="global-search-controls mt-6">
                        <div class="global-search-options">
                          <div class="flex items-center gap-2">
                            <p-radioButton inputId="global-search-serial-number" name="searchBy" formControlName="searchBy" value="serialNumber"></p-radioButton>
                            <label for="global-search-serial-number">
                              {{ 'WARRANTIES.SEARCH_BY_SERIAL_NUMBER' | translate }}
                            </label>
                          </div>

                          <div class="flex items-center gap-2">
                            <p-radioButton inputId="global-search-warranty-code" name="searchBy" formControlName="searchBy" value="warrantyCode"></p-radioButton>
                            <label for="global-search-warranty-code">
                              {{ 'WARRANTIES.SEARCH_BY_WARRANTY_CODE' | translate }}
                            </label>
                          </div>
                        </div>

                        <div class="global-search-input">
                          <label for="global-search-value" class="sr-only">
                            @if (globalSearchFormGroup.controls['searchBy'].value === 'serialNumber') {
                              {{ 'WARRANTIES.SEARCH_BY_SERIAL_NUMBER' | translate }}
                            } @else {
                              {{ 'WARRANTIES.SEARCH_BY_WARRANTY_CODE' | translate }}
                            }
                          </label>

                          <div class="flex items-stretch camera-btn-field-wr">
                            <input data-testid="global-search-input" type="text" id="global-search-value" formControlName="searchValue" autocomplete="off" disallowSpaces>

                            <textbox-camera data-testid="global-search-camera" class="shrink-0 self-stretch flex items-center" [disabled]="isGlobalSearchLoading" (qrCodeScanned)="onQRCodeScanned($event)">
                            </textbox-camera>
                          </div>
                        </div>

                        <button type="submit" data-testid="global-search-btn" class="btn primary-btn global-search-submit" [disabled]="isGlobalSearchLoading || !globalSearchFormGroup.controls['searchValue'].value?.trim()">
                          {{ 'WARRANTIES.BTN_SEARCH' | translate }}
                        </button>
                      </div>
                    </div>
                  </form>

                @if (!isGlobalSearchLoading) {
                  @if (!hasGlobalSearchSubmitted) {
                    <!-- Initial card -->
                    <div class="global-search-empty-state" data-testid="global-search-initial-message">
                      <p>{{ 'WARRANTIES.GLOBAL_SEARCH_INITIAL_MESSAGE' | translate }}</p>
                    </div>
                  } @else if (hasGlobalSearchError) {
                    <!-- Error message -->
                    <div class="flex flex-col items-center justify-center py-10 text-center" data-testid="global-search-error-message">
                      <p class="text-base">{{ 'WARRANTIES.GLOBAL_SEARCH_ERROR_MESSAGE' | translate }}</p>
                    </div>
                  } @else if (globalSearchResults.length === 0) {
                    <!-- No-results card -->
                    <div class="global-search-empty-state" data-testid="global-search-empty-message">
                      <p>{{ 'WARRANTIES.NO_DATA' | translate }}</p>
                    </div>
                  } @else if (globalSearchTableColumns.length) {
                    <!-- Results table -->
                    <p-table data-testid="global-search-table" [columns]="globalSearchTableColumns" [value]="globalSearchResults" class="mt-1">

                      <ng-template #header let-columns>
                        <tr>
                          @for (col of columns; track col; let colIndex = $index) {
                          <th>
                            @if (colIndex !== columns.length - 1) {
                            <div class="header-wr">
                              <span [attr.data-testid]="'global-search-table-header-' + colIndex" class="col-name">
                                {{ ('TABLE.HEADER.' + col.header) | translate }}
                              </span>
                            </div>
                            } @else {
                            <span class="col-name">
                              {{ ('TABLE.HEADER.' + col.field) | translate }}
                            </span>
                            }
                          </th>
                          }
                        </tr>
                      </ng-template>

                      <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
                        <tr>
                          @for (col of columns; track col; let colIndex = $index) {
                            <td [ngClass]="{'actions-col': colIndex === columns.length - 1}">
                              @if (colIndex !== columns.length - 1) {
                                <span [attr.data-testid]="'global-search-cell-' + colIndex + '-' + i" class="p-column-title">
                                  {{ ('TABLE.HEADER.' + col.header) | translate }}:
                                </span>

                                {{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}

                              } @else {
                                <div class="flex justify-center">
                                  <button type="button" pTooltip="{{ 'WARRANTIES.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye" [attr.data-testid]="'global-search-btn-view-' + i" (click)="goToGlobalWarrantyDetails(rowData)">
                                    <span class="btn-label">
                                      {{ 'WARRANTIES.VIEW_WARRANTY_DETAILS' | translate }}
                                    </span>
                                  </button>
                                </div>
                              }
                            </td>
                          }
                        </tr>
                      </ng-template>

                      <ng-template #emptymessage>
                        <tr>
                          <td [attr.colspan]="globalSearchTableColumns.length">
                            @if (!isGlobalSearchLoading) {
                              {{ 'WARRANTIES.NO_DATA' | translate }}
                            }
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  } @else {
                    <div class="global-search-empty-state" data-testid="global-search-no-columns-message">
                      <p class="text-base font-semibold">{{ 'TABLE.NO_COLUMNS_TITLE' | translate }}</p>
                      <p>{{ 'TABLE.NO_COLUMNS_MESSAGE' | translate }}</p>
                    </div>
                  }

                  @if (hasGlobalSearchSubmitted && submittedGlobalSearchBy === 'serialNumber' &&  !hasGlobalSearchError && globalSearchTableColumns.length && globalSearchTotalRecords > 0) {
                    <app-custom-paginator
                      data-testid="global-search-paginator"
                      [pageNumber]="globalSearchPageNumber"
                      [rows]="globalSearchPageSize"
                      [totalRecords]="globalSearchTotalRecords"
                      [rowsPerPageOptions]="[10, 20, 30]"
                      [showCurrentPageReport]="true"
                      [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                      [disabled]="isGlobalSearchLoading"
                      [alwaysShow]="true"
                      [showFirstLastIcon]="true"
                      [showPageLinks]="true"
                      [showPageSizeSelector]="true"
                      (onPageChange)="onGlobalSearchPageChange($event)">
                    </app-custom-paginator>
                  }
                }
                </div>
              </div>
            </p-tabpanel>
            <!-- /Tab 2 -->
          </p-tabpanels>
        </p-tabs>

      </div>
    </div>
  </div>
</div>
